import React from "react";
import { Component } from "react";
import { Project } from "./Project"

export class CurrentProjects extends Component {
    render() {
        return(
            <div>
                <Project mode="false"/>
            </div>
        );
    }
}